import { useSyncExternalStore } from "react"

// Nothing to subscribe to: the value only changes once, from the server snapshot to the browser's.
const subscribe = () => () => undefined

/**
 * False on the server and while React hydrates a prerendered page, true right after, and true from the start on a page
 * the browser renders from scratch. Gate what only the browser knows (localStorage, the window size) behind it, so the
 * browser's first render matches the prerendered HTML (src/entry-prerender.tsx) and React can keep it.
 */
export const useHydrated = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  )
